import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Stack,
  Table,
  Button,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
} from "@mui/material";
import moment from "moment";
import "./studentpayment.scss";
import { useQuery } from "@apollo/client";
import CreateInvoice from "./CreateInvoice";
import EmptyData from "../../Include/EmptyData";
import GenderImage from "../../../Assets/equality.png";
import EmptyImage from "../../../Assets/empty-image.png";
import CakeImage from "../../../Assets/birthday-cake.png";
import StudentPaymentAction from "./StudentPaymentAction";
import { currencyFormat } from "../../../Function/DynamicFn";
import { GET_STUDENT_PAYMENT_PAGINATION, GET_INVOICE_BY_STUDENT_PAGINATION } from "../../../Schema/StudentPayment";

export default function StudentPayment({ detailsData }) {
  // console.log("detailsData", detailsData);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [paginationData, setPaginationData] = useState();
  const [tableData, setTableData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);

  //=============== =================
  const { refetch } = useQuery(GET_INVOICE_BY_STUDENT_PAGINATION, {
    variables: {
      page: page,
      keyword: "",
      limit: limit,
      classId: null,
      programId: null,
      academicYearId: null,
      studentId: detailsData?._id,
    },
    onCompleted: ({ getInvoiceWithPagination }) => {
      console.log("getInvoiceWithPagination:::",getInvoiceWithPagination);
      setTableData(getInvoiceWithPagination?.data);
      setPaginationData(getInvoiceWithPagination?.paginator);
    },
    onError: (err) => {
      console.log(" getInvoiceWithPagination Error", err?.message);
    },
  });


  useEffect(() => {
    refetch();
  }, [page, limit, detailsData?._id]);

  const handleGetAdditional = (addArray) => {
    let totalAdd = 0;
    addArray?.map((row) => {
      totalAdd += row?.total
    })

    return totalAdd;
  }

  return (
    <div className="student-payment">
      <Box className="main-containner">
        <Grid item container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={3}>
            <Box className="profile-container">
              <Stack
                className="profile"
                direction="row"
                justifycontent="center"
                sx={{ marginBottom: "20px" }}
              >
                <img
                  className="avater-image"
                  style={{ borderRadius: "10px" }}
                  src={
                    detailsData?.profileImg === "" ||
                      detailsData?.profileImg === undefined ||
                      detailsData?.profileImg === null
                      ? EmptyImage
                      : detailsData?.profileImg?.slice(0, 5) === "https"
                        ? detailsData?.profileImg
                        : `${process.env.React_App_VIEW_URL}${detailsData?.profileImg}`
                  }
                />
              </Stack>
              <Typography className="name-container-khmer">
                {detailsData?.lastName ? detailsData?.lastName : " "}{" "}
                {detailsData?.firstName ? detailsData?.firstName : " "}
              </Typography>
              <Typography className="name-container">
                {detailsData?.englishName ? detailsData?.englishName : ""}
              </Typography>
              <Stack
                direction="row"
                justifyContent="center"
                sx={{ marginTop: "20px" }}
              >
                <Stack direction="row" spacing={4} sx={{ width: "70%" }}>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img
                        src={GenderImage}
                        alt="Gender"
                        className="cake-img"
                      />
                    </Stack>
                    <Typography className="cake-title">
                      {detailsData?.gender ? detailsData?.gender : ""}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="column"
                    spacing={1}
                    className="birthday-card"
                  >
                    <Stack direction="row" justifyContent="center">
                      <img src={CakeImage} alt="Gender" className="cake-img" />
                    </Stack>

                    <Typography className="cake-title">
                      {moment(detailsData?.dob).format("DD-MMM-YYYY")
                        ? moment(detailsData?.dob).format("DD-MMM-YYYY")
                        : ""}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={8} xl={9}>
            <Box className="details-container">
              <Stack direction="row" spacing={3} justifyContent="right">
                {/* <Box sx={{ width: "230px" }}>
                  <SelectAcademicYear
                    selectedVal={academicYearVal}
                    setSelectedVal={setAcademicYearVal}
                  />
                </Box>
                <Stack direction="row" spacing={1}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      inputFormat="dd-MM-yyyy"
                      mask="__-__-____"
                      value={from}
                      onChange={(e) => setFrom(e)}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider>
                </Stack> */}
                {/* <Button
                  className="btn-create-invoice"
                  startIcon={<LiaFileInvoiceDollarSolid />}
                  onClick={handleOpen}
                >
                  Create
                </Button>
                <CreateInvoice
                  open={open}
                  handleClose={handleClose}
                  studentId={detailsData?._id}
                  setRefetch={refetch}
                  detailsData={detailsData}
                /> */}
              </Stack>

              <Box className="table-payment">
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        className="tablecell-container"
                        sx={{
                          borderRadius: "10px 0px 0px 10px",
                        }}
                      >
                        IVN
                      </TableCell>
                      <TableCell className="tablecell-container">
                        Date
                      </TableCell>
                      {/* <TableCell align="center" className="tablecell-container">
                        Fee
                      </TableCell>
                      <TableCell align="center" className="tablecell-container">
                        Payment By
                      </TableCell> */}
                      <TableCell className="tablecell-container">
                        Total
                      </TableCell>
                      <TableCell
                        className="tablecell-container"
                        sx={{
                          borderRadius: "0px 10px 10px 0px",
                        }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>

                  {tableData?.length === 0 ? (
                    <TableBody className="body">
                      <TableRow className="body-row">
                        <TableCell className="tablecell-body" colSpan={5}>
                          <Stack
                            direction="column"
                            justifyContent="center"
                            height={315}
                          >
                            <EmptyData />
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    <>
                      <TableBody className="body">
                        {tableData?.map((row, index) => {
                          // console.log("row::", row);
                          return (
                            <TableRow className="body-row" key={index}>
                              <TableCell
                                className={
                                  row?.void
                                    ? "body-cell-start-void"
                                    : "body-cell-start"
                                }
                              >
                                {moment(row?.createdAt).format("YYYY")}-{row?.invoiceId?.toString()?.padStart(6, "0")}
                              </TableCell>

                              <TableCell
                                className={
                                  row?.void ? "body-cell-void" : "body-cell"
                                }
                              >
                                {moment(row?.createdAt).format("DD MMM YYYY")}
                              </TableCell>
                              {/* <TableCell className="body-cell">
                                $ 34,000
                              </TableCell>
                              <TableCell className="body-cell">
                                Brother Thorn
                              </TableCell> */}
                              <TableCell
                                className={
                                  row?.void ? "body-cell-void" : "body-cell"
                                }
                              >
                                $ {currencyFormat(row?.netAmount + handleGetAdditional(row?.additionalFee))}
                              </TableCell>
                              <TableCell
                                className={
                                  row?.void
                                    ? "body-cell-end-void"
                                    : "body-cell-end"
                                }
                                align="right"
                              >
                                <StudentPaymentAction
                                  editData={row}
                                  setRefetch={refetch}
                                  detailsData={detailsData}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </>
                  )}
                </Table>
                <Box className="box-seemore">
                  {tableData?.length >= limit ? (
                    <Button
                      className="btn-seemore"
                      onClick={() => setLimit(limit + 5)}
                    >
                      See more
                    </Button>
                  ) : null}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
